import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PWAThunk } from 'lib/core/data'
import { GTM } from 'lib/core/services/gtm'
import { HTTP_STATUS } from 'lib/core/resources/constants'
import { getIsLoggedIn } from 'lib/core/data/auth/session/selectors'
import { getCart } from 'lib/core/data/quote/cart/selectors'
import { Slice, PlaceOrderSlice, PlaceOrderData } from './types'
import { getOrderId } from './selectors'
import { completeCart } from 'lib/core/data/quote/cart'
import { CartData } from 'lib/core/data/quote/cart/types'
import { Ga4Events } from '../../../../gtm/index'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
  data?: PlaceOrderData
}

const getSlice = (slice: PlaceOrderSlice): PlaceOrderSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false,
    payload: undefined
  })
}

const slice = createSlice({
  name: 'quote/placeOrder',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = true
      state[cartId] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { cartId, data } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
      slice.payload = data
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { cartId, data } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
      slice.payload = data
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

interface PaymentMethod {
  method: string
  additional_data?: Record<string, any>
  po_number?: string
}

export interface OrderPayload {
  cartId: string
  payload?: {
    paymentMethod?: PaymentMethod | object
  }
}

export function placeOrder (cartId: string, cart?: CartData, paymentMethod?: PaymentMethod): PWAThunk {
  const payload = {
    paymentMethod
  }

  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({
      cartId
    }))

    try {
      const isLoggedIn = getIsLoggedIn(getState())

      const orderPayload: OrderPayload = {
        cartId,
        payload: {
          paymentMethod: {
            method: 'free'
          }
        }
      }
      if (paymentMethod) {
        orderPayload.payload = payload
      }

      const response = isLoggedIn
        ? await magentoClient.getClient().quote.placeOrder(orderPayload)
        : await magentoClient.getClient().quote.placeGuestOrder(orderPayload)

      dispatch(completeCart({ cartId }))

      const { data, status } = response

      if (data && cart) {
        GTM.purchase({
          orderId: data,
          cart
        })
        Ga4Events.purchase({
          orderId: data,
          cart
        })
      }

      if (status === HTTP_STATUS.OK) {
        dispatch(success({
          cartId,
          data
        }))

        const state = getState()
        let orderId = getOrderId(cartId)(state)

        try {
          const json = JSON.parse(orderId)
          orderId = json.increment_id
        } catch (e) {
          orderId = getOrderId(cartId)(state)
        }

        const cart = getCart(cartId)(state)

        if (orderId && cart?.data) {
          GTM.purchase({
            orderId,
            cart: cart.data
          })
          Ga4Events.purchase({
            orderId: orderId,
            cart: cart?.data
          })
        }
      } else {
        dispatch(failure({
          cartId,
          data
        }))
      }

      return response
    } catch (e) {
      dispatch(failure({
        cartId
      }))
    }
  }
}

// export function placeOrder (cartId, paymentMethodData) {
//   return async dispatch => {
//     dispatch(request(cartId))
//
//     try {
//       const { code, additionalData } = paymentMethodData
//       const paymentMethodPayload = {
//         method: {
//           method: code,
//           additional_data: additionalData || {}
//         }
//       }
//
//       const paymentMethodResponse = await api.quote.setPaymentMethod({
//         cartId,
//         payload: paymentMethodPayload
//       })
//
//       const { data: paymentMethodResponseData, status } = paymentMethodResponse
//       if (status === HTTP_STATUS.OK) {
//         const placeOrderResponse = await api.quote.placeOrder({ cartId })
//         const { data } = placeOrderResponse
//         const { placeOrder } = data || {}
//         const { order } = placeOrder || {}
//
//         if (order) {
//           dispatch(setCart(cartId, order))
//           dispatch(success(cartId))
//         } else {
//           dispatch(failure(cartId, data))
//         }
//
//         return placeOrderResponse
//       } else {
//         dispatch(failure(cartId, paymentMethodResponseData))
//       }
//     } catch (e) {
//       dispatch(failure(cartId))
//     }
//   }
// }
